<template>
  <div id="app">
    <keep-alive :include="['Show']">
      <router-view v-if="isRouterAlive"></router-view>
      <!-- <router-view></router-view> -->
    </keep-alive>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
    // Header
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  data () {
    return  {
      isRouterAlive: true
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => (this.isRouterAlive = true))
    }
  },
  // watch: {
  //   '$route' (to, from) {
  //     window.console.log("监听到路由变化")
  //     window.console.log(this.$route.name)
  //     window.console.log(to)
  //     window.console.log(from)
  //   }
  // }
}
</script>

<style>
#app {
}
</style>
